'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Offer = function () {
  function Offer(params) {
    _classCallCheck(this, Offer);

    this.params = params;
    this.setEquip();
    this.setLegal();
    this.setVehicleData();
    this.setGDPR();
  }

  _createClass(Offer, [{
    key: 'setEquip',
    value: function setEquip() {
      var json = this.params.offerJson;
      var data = json.vEquipoDest;
      var equip = JSON.parse(data);
      var $targetList = $(this.params.equip.list);
      var $itemTpl = $(this.params.equip.itemTpl);
      $targetList.empty();
      for (var i = 0; i < equip.length; i++) {
        var $it = $itemTpl.clone().removeAttr('id');
        $targetList.append($it.text(equip[i].vDestacado));
      }
    }
  }, {
    key: 'setLegal',
    value: function setLegal() {
      var legal = this.params.offerJson.vNotaLegal;
      var $target = $(this.params.legal.target);
      $target.html(legal);
    }
  }, {
    key: 'setVehicleData',
    value: function setVehicleData() {
      var version = this.params.vehicJson.vGrado;
      var motor = this.params.vehicJson.vMotor;

      var $modelTarget = $(this.params.model.target);
      var $versionTarget = $(this.params.version.target);
      var $motorTarget = $(this.params.motor.target);

      var offerJson = this.params.offerJson;

      $motorTarget.text(motor);
      $versionTarget.text(version);

      // Oferta financiera
      if (offerJson.bFinanciera) {

        var _offerJson = this.params.offerJson;
        console.log(_offerJson);
        var $finBlock = void 0;
        console.log("#1 $('#pvPeticion').val();", $('#pvPeticion').val());
        console.log("renting", renting);
        if (typeof renting !== 'undefined') {
          $finBlock = _offerJson.vProdFin === renting ? $(this.params.rentingBlock.target) : $(this.params.finBlock.target);
          if (_offerJson.vProdFin === renting) {
            $('#pvPeticion').val('RentingParticulares');
          }
        } else {
          $finBlock = $(this.params.finBlock.target);
        }
        console.log("#2 $('#pvPeticion').val();", $('#pvPeticion').val());
        var $duration = $finBlock.find('.js-fin-duration');
        var $deposit = $finBlock.find('.js-fin-deposit');
        var $deposit0 = $finBlock.find('.js-fin-deposit0');
        var $depositVal = $finBlock.find('.js-fin-deposit-val');
        var $tae = $finBlock.find('.js-fin-tae');
        var $finalpayment = $finBlock.find('.js-fin-finalpayment');
        var $km = $finBlock.find('.js-fin-km');

        $finBlock.removeClass('hidden');
        console.log(_offerJson);
        $duration.text('' + _offerJson.nDuracion);
        $tae.text('' + _offerJson.vTAE);
        $finalpayment.text('' + _offerJson.vVDMG);
        $km.text('' + _offerJson.nKilometraje);

        if (_offerJson.vEntrada === '0') {
          $deposit.addClass('hidden');
          $deposit0.removeClass('hidden');
        } else {
          $deposit.removeClass('hidden');
          $deposit0.addClass('hidden');
          $depositVal.text('' + _offerJson.vEntrada);
        }

        if (this.params.market === 'pt') {
          var $recompra = $finBlock.find('.js-fin-recompra');
          var $amountPay = $finBlock.find('.js-fin-amount-payable');
          var $amountPayVal = $finBlock.find('.js-fin-amount-payable-value');
          var $prodfin = $finBlock.find('.js-fin-prodfin');
          if (_offerJson.bRecompra !== 0) {
            $recompra.removeClass('hidden');
          }
          if (_offerJson.nCapitalFin !== 0) {
            $amountPay.removeClass('hidden');
            $amountPayVal.text('' + _offerJson.vCapitalFin);
          }
          $prodfin.text('' + _offerJson.vProdFin);
        }
      }

      // Texto Complementario al precio
      if (offerJson.vPrecioCompl.trim() !== '') {
        $(this.params.xtraBlock.target).removeClass('hidden').text(offerJson.vPrecioCompl);
      }
    }
  }, {
    key: 'setGDPR',
    value: function setGDPR() {
      $(this.params.gdprCheck).on('click', function () {
        var value = $(this).val();
        var newValue = void 0;

        if (value === '1') newValue = '0';else newValue = '1';

        $(this).val(newValue);
      });
    }
  }]);

  return Offer;
}();